import { Box, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { tokens } from "../../../theme";

// import { getOrderStatusCounts } from "../../../api/orders/orders";
import { useTranslation } from 'react-i18next';

import TabView3 from "../../../components/theme/TabView3/TabView3";
import { useTopbar } from "../../../contexts/TopbarProvider";
import AllShipments from "./Views/All";
import Claims from "./Views/Claims";
import {relationShipmentsConfig} from "./relationShipmentsConfig";
import ShipmentTotalsPanel from "../../../components/global/dashboard/ShipmentTotalsPanel";


const RelationShipments = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { showExtraTitle,clearExtraTitle } = useTopbar();

    const config = useMemo(() => relationShipmentsConfig(), []);

    // The totals panel belongs to the shipments tab, which reports whether it is the one open.
    const [shipmentsTabActive, setShipmentsTabActive] = useState(false);

    useEffect(() => {
        showExtraTitle(t("shipments"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {shipmentsTabActive && <ShipmentTotalsPanel forRelation />}

            <TabView3
                tabConfig={config}
                sx={{
                    width:1,
                    background:"green",
                    minHeight: shipmentsTabActive ? "calc(100% - 431px)" : "calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,

                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}
                title={t("outbound")}
                
            >
                <>
                    <AllShipments config={config.orderShipments} onActiveChange={setShipmentsTabActive}/>
                    <Claims config={config.claims}/>
                </>
            </TabView3>
        </Box>
    );
};

export default RelationShipments;